import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import ModalBase from '../ModalBase';

const InfoBlock = ({ label, value }) => (
  <div style={{ marginBottom: '15px' }}>
    <label style={styles.label}>{label}</label>
    <div style={styles.valueBox}>{value}</div>
  </div>
);

const QRCodeBlock = ({ address }) => (
  <div style={{ marginBottom: '15px' }}>
    <label style={{ fontSize: '14px', color: '#999' }}>QRCode</label>
    <div style={{ ...styles.valueBox, justifyContent: 'center' }}>
      <QRCodeCanvas
        id="qrCode"
        value={address}
        size={130}
        bgColor="#ffffff"
        level="H"
      />
    </div>
  </div>
);

const CryptoDeposit = ({ show, onClose, address, network, coin }) => {
  return (
    <ModalBase show={show} onClose={onClose}>
      <div style={styles.container}>
        <div style={styles.closeButtonContainer}>
          <button style={styles.closeButton} onClick={onClose}>
            &times;
          </button>
        </div>

        {/* Left Section */}
        <div style={styles.leftSection}>
          <h2 style={styles.title}>
            <img
              src={require("../../../assets/imgs/ico-higher-titulo.svg").default}
              alt="Logo Higher"
              style={styles.logo}
            />
            Deposit
          </h2>

          <InfoBlock label="Address" value={address} />
          <InfoBlock label="Network" value={network} />
          <InfoBlock label="Coin" value={coin} />
        </div>

        {/* Right Section */}
        <div style={styles.rightSection}>
          <QRCodeBlock address={address} />

          <button style={styles.okButton} onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </ModalBase>
  );
};

const styles = {
  closeButtonContainer: {
    position: 'absolute',
    top: '20px',
    right: '25px',
    zIndex: 10,
  },
  closeButton: {
    fontSize: '24px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#888',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderRadius: '10px',
    width: '100%',
    overflow: 'hidden',
    fontFamily: 'sans-serif',
    position: 'relative',
  },
  leftSection: {
    width: '50%',
    padding: '30px',
    borderRight: '1px solid #eee',
    boxSizing: 'border-box',
  },
  rightSection: {
    width: '48%',
    padding: '30px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',   
  },
  title: {
    fontSize: '24px',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    height: '35px',
    marginRight: '5px',
  },
  label: {
    color: '#aaa',
    fontSize: '12px',
  },
  valueBox: {
    backgroundColor: '#f7f7f8',
    padding: '10px',
    borderRadius: '5px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    display: 'flex',
  },
  okButton: {
    padding: '15px',
    backgroundColor: '#1c787e',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    marginTop: 'auto',
  },
};

export default CryptoDeposit;
